const InnerTabHover = ({ isActiveTab }: { isActiveTab: boolean }) => (
  <div
    className={`absolute -inset-x-px inset-y-0 pointer-events-none rounded-t-lg !bg-[var(--ds-inner-tab-hover-and-active-bg)] group-hover:opacity-100 transition-opacity ${
      isActiveTab ? 'opacity-100' : 'opacity-0'
    }`}
  />
);

export default InnerTabHover;
